module.exports = __webpack_public_path__ + "static/media/img-3.8bb5dc9e.png";